type AttributeStates = Record<string, Set<string>>;

type AttributeMessages = Record<string, string[]>;

const splitEntry = (entry: string): [string, string] => {
    const index = entry.indexOf(':');
    return index >= 0 ? [entry.slice(0, index).trim(), entry.slice(index + 1).trim()] : ['', entry.trim()];
};

/** Parses `attributeStates__` (`<attribute>:<state>,<state>`) into a lookup by attribute. */
const parseAttributeStates = (entries: string[] | undefined): AttributeStates => {
    const states: AttributeStates = {};
    for (const entry of entries ?? []) {
        const [attribute, list] = splitEntry(entry);
        if (!attribute) {
            continue;
        }
        const set = states[attribute] ?? new Set<string>();
        list.split(',').map((state) => state.trim()).filter(Boolean).forEach((state) => set.add(state));
        states[attribute] = set;
    }
    return states;
};

/**
 * Groups `validation__` / `validation_warnings__` (`<attribute>:<key>`) by attribute.
 * Entries without an attribute prefix land under `''` and are shown as asset-level messages.
 */
const groupMessagesByAttribute = (entries: string[] | undefined): AttributeMessages => {
    const grouped: AttributeMessages = {};
    for (const entry of new Set(entries ?? [])) {
        const [attribute, key] = splitEntry(entry);
        if (!key) {
            continue;
        }
        (grouped[attribute] ??= []).push(key);
    }
    return grouped;
};

const countMessages = (messages: AttributeMessages) =>
    Object.values(messages).reduce((total, keys) => total + keys.length, 0);

export { type AttributeMessages, type AttributeStates, countMessages, groupMessagesByAttribute, parseAttributeStates };
